'use strict';

export default class StorageUtils {
    static getItem(key, defaultValue) {
        if (key === undefined || key === null || !window.localStorage) {
            return defaultValue;
        }

        const value = window.localStorage.getItem(key);

        return value === undefined || value === null ? defaultValue : value;
    }

    static setItem(key, value) {
        if (key === undefined || !window.localStorage) {
            return false;
        }

        let v = value;

        if (typeof value === "object") {
          try {
            v = JSON.stringify(v);
          } catch(e) {
            return false;
          }
        } else if (typeof value === "string") {
          v = value;
        } else {
          console.log("Unsupported type of object");
          return false;
        }

        window.localStorage.setItem(key, v);

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/javascript-classes/utils/storage.js